import { useState } from 'react';

const MEDIA_DATA = [
  {
    title: '长安风云录 · 大结局名场面',
    dur: '05:32',
    views: '128万',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20scene%20still%20from%20a%20historical%20Chinese%20drama%2C%20elegant%20palace%20interior%20with%20warm%20candlelight%2C%20traditional%20costumes%20with%20rich%20embroidery%2C%20warm%20amber%20and%20gold%20tones%2C%20soft%20focus%20background%2C%20film%20still%20aesthetic%2C%20high%20quality%20cinematic%20color%20grading&width=640&height=360&seq=media-scene-01&orientation=landscape',
    imgAlt: '长安风云录大结局名场面',
  },
  {
    title: '都市夜归人 · 天台告白片段',
    dur: '03:18',
    views: '96万',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20scene%20still%20from%20a%20modern%20office%20drama%2C%20sleek%20corporate%20setting%20with%20warm%20ambient%20lighting%2C%20professional%20atmosphere%2C%20warm%20golden%20hour%20light%20through%20floor%20to%20ceiling%20windows%2C%20film%20still%20aesthetic%2C%20high%20quality%20cinematic%20color%20grading&width=640&height=360&seq=media-scene-02&orientation=landscape',
    imgAlt: '都市夜归人天台告白片段',
  },
  {
    title: '暗夜追踪 · 终极反转时刻',
    dur: '04:45',
    views: '156万',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20scene%20still%20from%20a%20mystery%20thriller%2C%20atmospheric%20interrogation%20room%20with%20dramatic%20side%20lighting%2C%20warm%20amber%20and%20shadow%20interplay%2C%20film%20still%20aesthetic%2C%20high%20quality%20cinematic%20color%20grading%2C%20suspenseful%20mood&width=640&height=360&seq=media-scene-03&orientation=landscape',
    imgAlt: '暗夜追踪终极反转时刻',
  },
  {
    title: '遇见你的季节 · 初雪吻戏',
    dur: '02:56',
    views: '203万',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20scene%20still%20from%20a%20romantic%20drama%2C%20couple%20walking%20through%20autumn%20park%20with%20golden%20leaves%2C%20warm%20soft%20backlight%2C%20dreamy%20bokeh%20background%2C%20film%20still%20aesthetic%2C%20high%20quality%20cinematic%20color%20grading%2C%20romantic%20atmosphere&width=640&height=360&seq=media-scene-04&orientation=landscape',
    imgAlt: '遇见你的季节初雪吻戏',
  },
  {
    title: '家的方向 · 团圆饭催泪弹',
    dur: '06:12',
    views: '89万',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20scene%20still%20from%20a%20family%20drama%2C%20warm%20dining%20room%20scene%20with%20golden%20evening%20light%2C%20family%20gathered%20around%20table%2C%20heartwarming%20atmosphere%2C%20film%20still%20aesthetic%2C%20high%20quality%20cinematic%20color%20grading%2C%20intimate%20home%20setting&width=640&height=360&seq=media-scene-05&orientation=landscape',
    imgAlt: '家的方向团圆饭催泪弹',
  },
];

const COMMENTS_DATA = [
  {
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20toned%20abstract%20avatar%20with%20soft%20orange%20gradient%2C%20minimalist%20style%2C%20clean%20simple%20background&width=80&height=80&seq=avatar-01&orientation=squarish',
    date: '2026-07-30',
    rating: 5,
    content: '桔子影院真的是宝藏网站！全集完整版不用等更新，画质还特别清晰。长安风云录一口气追完60集太过瘾了，强烈推荐给所有追剧党！',
  },
  {
    name: '深夜看剧人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20toned%20abstract%20avatar%20with%20soft%20amber%20gradient%2C%20minimalist%20style%2C%20clean%20simple%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
    date: '2026-07-29',
    rating: 5,
    content: '每天下班回家就是打开桔子影院追剧，资源太全了而且没广告打扰。海外剧的中文字幕质量也很高，日剧韩剧美剧随便看。',
  },
  {
    name: '剧荒拯救者',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20toned%20abstract%20avatar%20with%20soft%20peach%20gradient%2C%20minimalist%20style%2C%20clean%20simple%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    date: '2026-07-28',
    rating: 4,
    content: '之前一直剧荒，朋友推荐了桔子影院之后简直打开了新世界。专题分类做得很清楚，按题材找剧很方便，已经成功安利给身边所有人。',
  },
  {
    name: '古装剧十级学者',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20toned%20abstract%20avatar%20with%20soft%20coral%20gradient%2C%20minimalist%20style%2C%20clean%20simple%20background&width=80&height=80&seq=avatar-04&orientation=squarish',
    date: '2026-07-27',
    rating: 5,
    content: '作为一个古装剧重度爱好者，这里的古装剧资源太丰富了。从经典老剧到最新热播，高清画质看古装细节真的是一种享受。',
  },
  {
    name: '追剧不剧荒',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20warm%20toned%20abstract%20avatar%20with%20soft%20gold%20gradient%2C%20minimalist%20style%2C%20clean%20simple%20background&width=80&height=80&seq=avatar-05&orientation=squarish',
    date: '2026-07-26',
    rating: 5,
    content: '手机上看也很流畅，通勤路上追剧太方便了。更新速度真的快，大结局上线就能看，再也不用担心被朋友圈剧透了！',
  },
];

export function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50 scroll-mt-16">
      <div className="max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          联系我们
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          如有任何问题、建议或合作意向，欢迎通过以下方式与我们联系
        </p>
        <div className="bg-background-100 rounded-2xl p-8 md:p-10">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-mail-line text-xl text-primary-600"></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">电子邮箱</h3>
              <p className="text-xs text-foreground-500">contact@juzicinema.com</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-wechat-line text-xl text-accent-600"></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">官方微信</h3>
              <p className="text-xs text-foreground-500">桔子影院官方号</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-message-2-line text-xl text-secondary-600"></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">意见反馈</h3>
              <p className="text-xs text-foreground-500">在线提交反馈表</p>
            </div>
          </div>
          <div className="mt-8 pt-6 border-t border-background-200/60 text-center">
            <p className="text-xs text-foreground-400">
              工作日 9:00 - 18:00 在线回复 · 我们会在24小时内处理您的来信
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-16">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          精彩花絮
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          热门剧集高能片段与幕后花絮精选
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {MEDIA_DATA.map((item) => (
            <article key={item.title} className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-xl mb-3 aspect-video bg-background-200">
                <img
                  src={item.img}
                  alt={item.imgAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-xl text-primary-600 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2">
                  <span className="px-2 py-0.5 rounded-md bg-black/60 text-background-50 text-xs whitespace-nowrap">
                    {item.dur}
                  </span>
                </div>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500">
                <i className="ri-eye-line mr-1"></i>{item.views} 次观看
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50 scroll-mt-16">
      <div className="max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          关于桔子
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          了解桔子影院背后的故事
        </p>
        <div className="bg-background-100 rounded-2xl p-8 md:p-10">
          <div className="prose prose-sm max-w-none">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              桔子影院创立于2024年，致力于为广大剧迷打造一个免费、高清、全面的电视剧在线观看平台。我们深知每一位追剧爱好者的需求——<strong>不需要繁琐的注册流程，不想要恼人的广告打扰，只希望打开网页就能畅享完整剧集</strong>。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              目前，桔子影院已收录超过<strong>10,000部电视剧全集完整剧集</strong>，涵盖国产剧、海外剧、古装剧、都市剧、悬疑剧等多种题材。我们与内容合作方保持紧密协作，每日更新同步热播剧集，确保剧迷朋友们追剧不等待。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              在观影体验方面，桔子影院全站支持<strong>1080P高清画质</strong>，采用智能编码技术优化带宽使用，即使在移动网络环境下也能流畅播放。我们同时适配电脑、平板和手机浏览器，让追剧不受设备和场景限制。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              未来，桔子影院将继续扩展剧集资源库，优化播放体验，努力成为华语地区最受欢迎的免费在线追剧平台。感谢每一位剧迷的支持与陪伴。
            </p>
          </div>
          <div className="mt-8 grid grid-cols-3 gap-4 text-center">
            <div className="bg-background-50 rounded-xl p-4">
              <div className="text-lg md:text-xl font-bold text-primary-600 font-heading whitespace-nowrap">10,000+</div>
              <div className="text-xs text-foreground-500 mt-1">剧集资源</div>
            </div>
            <div className="bg-background-50 rounded-xl p-4">
              <div className="text-lg md:text-xl font-bold text-accent-600 font-heading whitespace-nowrap">500万+</div>
              <div className="text-xs text-foreground-500 mt-1">月活用户</div>
            </div>
            <div className="bg-background-50 rounded-xl p-4">
              <div className="text-lg md:text-xl font-bold text-primary-600 font-heading whitespace-nowrap">99.9%</div>
              <div className="text-xs text-foreground-500 mt-1">服务稳定率</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function CommentsSection() {
  const [expandedId, setExpandedId] = useState<number | null>(null);

  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-16">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          剧迷热评
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          听听追剧同好们怎么说
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {COMMENTS_DATA.map((comment, i) => {
            const isExpanded = expandedId === i;
            const shouldTruncate = comment.content.length > 60;
            return (
              <div key={i} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-accent-100 overflow-hidden flex-shrink-0">
                    <img
                      src={comment.avatar}
                      alt={comment.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-heading text-sm font-semibold text-foreground-900 whitespace-nowrap">
                      {comment.name}
                    </h3>
                    <p className="text-xs text-foreground-400">{comment.date}</p>
                  </div>
                  <div className="flex items-center gap-0.5">
                    {Array.from({ length: comment.rating }).map((_, j) => (
                      <i key={j} className="ri-star-fill text-xs text-accent-500"></i>
                    ))}
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {shouldTruncate && !isExpanded ? comment.content.slice(0, 60) + '...' : comment.content}
                  {shouldTruncate && (
                    <button
                      onClick={() => setExpandedId(isExpanded ? null : i)}
                      className="text-primary-600 hover:text-primary-700 ml-1 text-sm cursor-pointer"
                    >
                      {isExpanded ? '收起' : '展开'}
                    </button>
                  )}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}